import { useContext } from "react";
import { DependenciesContext } from "../providers/Dependencies";
import { Config } from "../../appConfig";

export function useConfig(): Config {
  const dependencies = useContext(DependenciesContext);
  if (!dependencies) {
    throw new Error("Dependencies container is null, did you forget to pass it to the provider?");
  } else {
    return dependencies.config;
  }
}
